export const setList = (state, payload) => state.list = payload
export const setAll = (state, payload) => state.all = payload
export const removeItem = (state, payload) => state.list.splice(payload, 1)
export const setCompany = (state, payload) => state.company = payload
export const setBusiness = (state, payload) => state.business = payload
export const updateRoleById = (state, { id, roles }) => {
  const findIndex = state.list.data.findIndex(company => company.id === id);

  state.list.data[findIndex].roleList = roles;
}
